import React, { useEffect, useState } from 'react'
import { Button, Menu, Segment, Sidebar } from 'semantic-ui-react'
import PyramidReport from '../../components/Reports/PyramidReport';
import { GetReports } from '../../api/services/shared';
import { ETL } from '../../api/services/next';

/* eslint-enable react/display-name */
const PyramidReportsTab = () => {
    const [reports, setReports] = useState([])
    const [report, setReport] = useState(null)
    const [url, setURL] = useState([])
    const [showMenu, setShowMenu] = useState(true)

    useEffect(() => {


        (async () => {

            var localUrl = await ETL.GetAnalyticsURL();

            setURL(localUrl);

            var domain = window.location.hostname;
            try {
                await ETL.Authenticate(domain);
            }
            catch (error) {
                console.log(error);
            }

            setReports(await GetReports({ CategoryID: 9 }));
        })()
    }, [])


    return (
        <Sidebar.Pushable>
            <Sidebar onHide={() => setShowMenu(false)}
                vertical
                animation='overlay'
                visible={showMenu} as={Menu}>
                {
                    reports.map(report => {
                        return <Menu.Item key={report.Id} onClick={() => setReport(report)}>{report.Name}</Menu.Item>
                    })
                }
            </Sidebar>
            <Sidebar.Pusher style={{display: "flex"}}>
                <Segment style={{flex: 1}}>
                <Button onClick={() => setShowMenu(true)} style={{
                    position: "absolute",top: 5, left: 5,zIndex: 10}} icon="bars"></Button>
                    {report && <PyramidReport key={report.Id} ReportID={report.Url} URL={url} />}
                </Segment>
            </Sidebar.Pusher>
        </Sidebar.Pushable>
    )
}

export default PyramidReportsTab 